import React, { useState, useEffect } from 'react';
import LeaseApiService from '../../services/apiService';
import { FaSave, FaChevronLeft } from 'react-icons/fa';
import { ClipLoader } from 'react-spinners';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import PersonalDetails from './personalDetails';
import ContactDetails from './contactDetails';
import DocumentDetails from './documentDetails';
import Activity from './activity';
import GLAccount from './GLAccounts';
import PreferenceDetails from './preference';
import { getCountryFromCurrency } from '../../../INVENTORY/Layouts/currencyHelpers';
import AddressDetails from './additionalAddress';
import { toast } from 'react-toastify';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { getCompany, getName } from '../../../Redux/selecters';
import DependentDetails from './dependentDetails';
import { useTranslation } from 'react-i18next';

const ViewCustomerMaster = ({ rowData, onClose }) => {
  const { t } = useTranslation();
  const apiService = new LeaseApiService();
  const { currencyPrecision } = useCurrency();
  const userName = useSelector(getName);
  const currencyList = JSON.parse(localStorage.getItem('currencylist')) || [];
  const defaultCountry = currencyPrecision?.code ? getCountryFromCurrency(currencyPrecision?.code, currencyList) : 'bh'; // fallback until API loads
  const [activeFY, setActiveFY] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [gridVisibility, setGridVisibility] = useState([true, false, false, false, false, false, false, false, false]);
  const [loading, setloader] = useState(false);
  const [contactList, setContactList] = useState([]);
  const [addressList, setAddressList] = useState([]);
  const [documentsList, setDocumentsList] = useState([]);
  const [activityList, setActivityList] = useState([]);
  const [preferenceList, setPreferenceList] = useState([]);
  const [sourceList, setSourceList] = useState([]);
  const [customerTypeList, setCustomerTypeList] = useState([]);
  const [salesPersonList, setSalesPersonList] = useState([]);
  const [leadStatus, setLeadStatus] = useState([]);
  const [agentList, setAgentList] = useState([]);
  const [packageName, setPackageName] = useState([]);
  const [propertylist, setPropertyList] = useState([]);
  const [titleList, setTitleList] = useState([]);
  const [leadType, setLeadType] = useState([]);
  const [dependentList, setDependentList] = useState([]);
  const [personalTabLeadType, setPersonalTabLeadType] = useState([]);
  const [activityRating, setActivityRating] = useState([]);
  const [language, setLanguage] = useState([]);
  const [woContact, setWOContact] = useState([]);
  const [activityStatus, setActivityStatus] = useState([]);
  const [ativityLeadType, setActivityLeadType] = useState([]);
  const [categoryMix, setCategoryMix] = useState([]);
  const [taxList, setTaxList] = useState([]);
  const [acountCodes, setAccountCodes] = useState([]);
  const [addContactType, setAddContactType] = useState([]);
  const [addAddressType, setAddAddressType] = useState([]);
  const [documentType, setDocumentType] = useState([]);
  const [prefIntrest, setPrefIntrest] = useState([]);
  const [prefBuying, setPrefBuying] = useState([]);
  const [locationMaster, setLocationMaster] = useState([]);
  const [UnitClass, setUnitClass] = useState([]);
  const [Properties, setProperties] = useState([]);
  const [UnitView, setUnitView] = useState([]);
  const [UnitTypeDesc, setUnitTypeDesc] = useState([]);
  const [UnitModel, setUnitModel] = useState([]);
  const [bedRooms, setBedRooms] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [countriesList, setCountries] = useState([]);
  const [nationalityList, setNationalitylist] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [loader, setLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);

  const userData = rowData;

  const validationRules = [
    { key: 'type', message: t('customerMaster.validationMessages.selectType') },
    { key: 'title', message: t('customerMaster.validationMessages.selectTitle') },
    { key: 'fullName', message: t('customerMaster.validationMessages.enterFullName') },
    { key: 'mobileNo', message: t('customerMaster.validationMessages.enterMobileNo') },
    { key: 'email', message: t('customerMaster.validationMessages.enterEmail') },
    // { key: 'leadtype', message: 'Please Enter Lead Type' },
    { key: 'nationality', message: t('customerMaster.validationMessages.enterNationality') },
    // { key: 'source', message: 'Please Enter Source' },
    // { key: 'subsource', message: 'Please Enter Sub Source' },
    // { key: 'salesPerson', message: 'Please Enter Sales Person' },
    // { key: "dateofBirth", message: "Please Enter Date Of Birth" },
  ];
  const [gLAccounts, setGLAccounts] = useState({
    subgroup: null,
    accountcode: null,
    accountname: null,
    createledger: false,
    sgAccount: null,
    dateofBirth: null,
    vatNo: '',
    birthPlace: '',
    remarks: '',
    idNo: '',
    taxCode: null,
    issueDate: null,
    expiryDate: null,
    countryIssue: null,
    categoryMix: null,
  });
  const [transectionData, setTransectionData] = useState({
    salesPerson: '',
    type: '',
    mobileNo: '',
    agent: '',
    fullName: '',
    title: '',
    email: '',
    firstName: '',
    gender: '',
    lastName: '',
    phoneNo: '',
    poBox: '',
    categoryMix: '',
    salesPerson: '',
    address: '',
    dateofBirth: '',
    firstNameAR: '',
    lastNameAR: '',
    addressAR: '',
    source: '',
    designatoin: '',
    subsource: '',
    leadtype: '',
    countryCode: '',
    companyName: '',
    designation: '',
    nationality: null,
    productType: null,
  });

  useEffect(() => {
    setUserDate();
    const financialYears = JSON.parse(localStorage.getItem('financialYear')) || [];
    const activeFinancialYear = financialYears?.find((fy) => fy.isActive);
    if (activeFinancialYear) {
      setActiveFY({ label: activeFinancialYear.name, value: activeFinancialYear });
    }
  }, []);

  const setUserDate = async () => {
    try {
      setLoading(true);
      setTableLoading(true);
      const params1 = new URLSearchParams();
      params1.append(
        'dropdownTypes',
        'CustSource,SalesPersons,CustomerType,CustTitles,CustSource,CustAgents,LeadType,ActivityRating,CustPackageNames,PersonalTabLeadType',
      );
      const res1 = await apiService.getApiParamater('CUSTOMER_RA_MULTI', `?${params1.toString()}`);
      setSourceList(res1?.data?.dropdowns?.custSource);
      setCustomerTypeList(res1?.data?.dropdowns?.customerType);
      setSalesPersonList(res1?.data?.dropdowns?.salesPersons);
      setAgentList(res1?.data?.dropdowns?.agents);
      setPackageName(res1?.data?.dropdowns?.custPackageNames);
      setTitleList(res1?.data?.dropdowns?.custTitles);
      setLeadType(res1?.data?.dropdowns?.leadType);
      setPersonalTabLeadType(res1?.data?.dropdowns?.personalTabLeadType);
      setActivityRating(res1?.data?.dropdowns?.activityRating);
      // DropDown 2nd List

      const params2 = new URLSearchParams();
      params2.append(
        'dropdownTypes',
        'CategoryMix,TaxMaster,AccountCodes,AddContactType,AddAddressType,DocumentType,PrefIntrest,PrefBuying,LocationMaster,ActivityWayofContact,ActivityLanguage',
      );
      const res2 = await apiService.getApiParamater('CUSTOMER_RA_MULTI', `?${params2.toString()}`);
      setCategoryMix(res2?.data?.dropdowns?.categoryMix);
      setTaxList(res2?.data?.dropdowns?.taxMaster);
      setAccountCodes(res2?.data?.dropdowns?.accountCodes);
      setAddContactType(res2?.data?.dropdowns?.addContactType);
      setAddAddressType(res2?.data?.dropdowns?.addAddressType);
      setDocumentType(res2?.data?.dropdowns?.documentType);
      setPrefIntrest(res2?.data?.dropdowns?.prefIntrest);
      setPrefBuying(res2?.data?.dropdowns?.prefBuying);
      setLocationMaster(res2?.data?.dropdowns?.locationMaster);
      setLanguage(res2?.data?.dropdowns?.activityLanguage);
      setWOContact(res2?.data?.dropdowns?.activityWayofContact);
      // DropDown 3rd List

      const params3 = new URLSearchParams();
      params3.append(
        'dropdownTypes',
        'UnitClass,Properties,UnitView,UnitTypeDesc,UnitModel,BedRooms,Country,Nationality,PrefProperties,ActivityLeadType,ActivityStatus',
      );
      const res3 = await apiService.getApiParamater('CUSTOMER_RA_MULTI', `?${params3.toString()}`);
      setUnitClass(res3?.data?.dropdowns?.unitClass);
      setProperties(res3?.data?.dropdowns?.properties);
      setUnitView(res3?.data?.dropdowns?.unitView);
      setUnitTypeDesc(res3?.data?.dropdowns?.unitTypeDesc);
      setUnitModel(res3?.data?.dropdowns?.unitModel);
      setBedRooms(res3?.data?.dropdowns?.bedRooms);
      setCountries(res3?.data?.dropdowns?.country);
      setNationalitylist(res3?.data?.dropdowns?.nationality);
      setPropertyList(res3?.data?.dropdowns?.prefProperties);
      setActivityLeadType(res3?.data?.dropdowns?.activityLeadType);
      setActivityStatus(res3?.data?.dropdowns?.activityStatus);

      const params = new URLSearchParams();
      params.append('Action', 'GetCustomerDetailsByCustomerNo');
      params.append('TenantNo', userData?.customerNo);
      const res = await apiService.getApiParamater('CUSTOMER_RA_COMMON', `?${params.toString()}`);
      let usrDAta = res?.data?.result?.data;
      const selectedtax = res2?.data?.dropdowns?.taxMaster?.find((item) => item.value === usrDAta.taxCode?.toString());
      setSelectedCountry(usrDAta?.maincountry ? { label: usrDAta.maincountry, value: usrDAta.maincountry } : null);
      setSelectedCity(usrDAta?.maincity ? { label: usrDAta.maincity, value: usrDAta.maincity } : null);
      setTransectionData((prev) => ({
        ...prev,
        type: usrDAta?.customertype ? { label: usrDAta.customertype === '0' ? '' : usrDAta.customertype, value: usrDAta.customertype } : null,
        title: usrDAta?.title ? { label: usrDAta.title === '0' ? '' : usrDAta.title, value: usrDAta.title } : null,
        fullName: usrDAta?.customer_Name === '0' ? '' : usrDAta?.customer_Name || '',
        firstName: usrDAta?.occupation === '0' ? '' : usrDAta?.occupation || '',
        lastName: usrDAta?.department === '0' ? '' : usrDAta?.department || '',
        email: usrDAta?.email_id === '0' ? '' : usrDAta?.email_id || '',
        mobileNo: usrDAta?.exp6 + usrDAta?.mainContactno || '',
        status: usrDAta?.status === '0' ? '' : usrDAta?.status || 'Active',
        address: usrDAta?.mainaddress1 === '0' ? '' : usrDAta?.mainaddress1 || '',
        poBox: usrDAta?.pobox === '0' ? '' : usrDAta?.pobox || '',
        country: usrDAta?.maincountry ? { label: usrDAta.maincountry === '0' ? '' : usrDAta?.maincountry, value: usrDAta.maincountry } : null,
        city: usrDAta?.maincity ? { label: usrDAta.maincity === '0' ? '' : usrDAta.maincity, value: usrDAta.maincity } : null,
        nationality: usrDAta?.nationality ? { label: usrDAta.nationality === '0' ? '' : usrDAta.nationality, value: usrDAta.nationality } : null,
        source: usrDAta?.source ? { label: usrDAta.source === '0' ? '' : usrDAta.source, value: usrDAta.source } : null,
        agent: usrDAta?.agent ? { label: usrDAta.agent === '0' ? '' : usrDAta.agent, value: usrDAta.agent } : null,
        salesPerson: usrDAta?.salesPerson ? { label: usrDAta.salesPerson === '0' ? '' : usrDAta.salesPerson, value: usrDAta.salesPerson } : null,
        leadtype: usrDAta?.exp4 ? { label: usrDAta.exp4 === '0' ? '' : usrDAta.exp4, value: usrDAta.exp4 } : null,
        subsource: usrDAta?.exp5 ? { label: usrDAta.exp5 === '0' ? '' : usrDAta.exp5, value: usrDAta.exp5 } : null,
        productType: usrDAta?.exp16 ? { label: usrDAta.exp16 === '0' ? '' : usrDAta.exp16, value: usrDAta.exp16 } : null,
        gender: usrDAta?.exp14 ? { label: usrDAta.exp14 === '0' ? '' : usrDAta.exp14, value: usrDAta.exp14 } : null,
        firstNameAR: usrDAta?.exp1 === '0' ? '' : usrDAta?.exp1 || '',
        lastNameAR: usrDAta?.exp2 === '0' ? '' : usrDAta?.exp2 || '',
        addressAR: usrDAta?.exp9 === '0' ? '' : usrDAta?.exp9 || '',
        designation: usrDAta?.contactaddress === '0' ? '' : usrDAta?.contactaddress || '',
        countryCode: usrDAta?.exp6 ? { dialCode: usrDAta.exp6 } : null,
        dateofBirth: usrDAta?.cdate === '0' ? '' : usrDAta?.cdate || null,
        companyName: usrDAta?.exp8 === '0' ? '' : usrDAta?.exp8 || '',
        Exp6: usrDAta?.exp6 === '0' ? '' : usrDAta?.exp6 || '',
      }));
      setGLAccounts((prev) => ({
        ...prev,
        accountcode: usrDAta?.accountCode === '0' ? '' : usrDAta?.accountCode || '',
        accountname: usrDAta?.accountName === '0' ? '' : usrDAta?.accountName || '',
        sgAccount: usrDAta?.sgcode === '0' ? '' : usrDAta?.sgcode || '',
        vatNo: usrDAta?.vatregNo === '0' ? '' : usrDAta?.vatregNo || '',
        taxCode: usrDAta?.taxCode ? { label: selectedtax.text || null, value: selectedtax || null } : null,
        remarks: usrDAta?.remarks === '0' ? '' : usrDAta?.remarks || '',
        idNo: usrDAta?.tradeLicNo === '0' ? '' : usrDAta?.tradeLicNo || '',
        issueDate: usrDAta?.tl_issue_date === '0' ? '' : usrDAta?.tl_issue_date || null,
        expiryDate: usrDAta?.tl_Expiry_date === '0' ? '' : usrDAta?.tl_Expiry_date || null,
        categoryMix: usrDAta?.category_Mix ? { label: usrDAta.category_Mix || null, value: usrDAta.category_Mix || null } : null,
        dateofBirth: usrDAta?.cdate === '0' ? '' : usrDAta?.cdate || null,
      }));

      const contactparams = new URLSearchParams();
      contactparams.append('Action', 'GetAdditionalContactsByCustomerNo');
      contactparams.append('TenantNo', userData?.customerNo);
      const ContactRes = await apiService.getApiParamater('CUSTOMER_RA_COMMON', `?${contactparams.toString()}`);
      let contactData = ContactRes?.data?.result?.data;
      const normalizeArray = (data) => (Array.isArray(data) ? data : data ? [data] : []);

      const rawContactData = normalizeArray(ContactRes?.data?.result?.data);

      const mappedContacts = rawContactData.map((item) => ({
        // Backend's AdditionalContactRADetails has "contact_type", not "contact_type_id"
        type: { label: item?.contact_type, value: item?.contact_type } || null,
        // Defensive dual-casing: unconfirmed whether Dapper's dynamic rows go
        // through the same camelCase key policy as typed responses (verified
        // for Dependents, not independently confirmed here) - check both.
        contactPerson: item?.contactPersonBI ?? item?.ContactPersonBI ?? '',
        phone: item?.contact_no || '',
        id: item?.cd_id,
        countryCode: item?.country_code || '',
      }));

      setContactList(mappedContacts);

      const addressparams = new URLSearchParams();
      addressparams.append('Action', 'GetAdditionalAddressByCustomerNo');
      addressparams.append('TenantNo', userData?.customerNo);
      const addressRes = await apiService.getApiParamater('CUSTOMER_RA_COMMON', `?${addressparams.toString()}`);
      const rawAddressData = normalizeArray(addressRes?.data?.result?.data);
      // Defensive dual-casing (see note above) - AdditionalAddressRADetails'
      // fields are all SCREAMING_SNAKE_CASE, so it's unclear whether the raw
      // SQL result keeps that casing as-is or gets partially camelCased.
      const mappedAddresses = rawAddressData.map((item) => {
        const typeVal = item?.address_TYPE_ID ?? item?.ADDRESS_TYPE_ID ?? '';
        const poBoxVal = item?.pobox ?? item?.POBOX ?? '';
        const idVal = item?.cd_ID ?? item?.CD_ID;
        const line1Val = item?.line1 ?? item?.LINE1 ?? '';
        const line2Val = item?.line2 ?? item?.LINE2 ?? '';
        const countryVal = item?.country_CODE ?? item?.COUNTRY_CODE ?? '';
        const cityVal = item?.city_CODE ?? item?.CITY_CODE ?? '';
        return {
          type: typeVal ? { label: typeVal, value: typeVal } : null,
          poBox: poBoxVal,
          id: idVal,
          address1: line1Val,
          address2: line2Val,
          country: countryVal ? { label: countryVal, value: countryVal } : null,
          city: cityVal ? { label: cityVal, value: cityVal } : null,
        };
      });

      const dependentParam = new URLSearchParams();
      dependentParam.append('Action', 'GetDependentsByCustomerNo');
      dependentParam.append('TenantNo', userData?.customerNo);
      const dependentRes = await apiService.getApiParamater('CUSTOMER_RA_COMMON', `?${dependentParam.toString()}`);
      const rawData = normalizeArray(dependentRes?.data?.result?.data);
      const mappDependent = rawData.map((item) => ({
        type: { label: item?.relationType, value: item?.relationType } || null,
        recordId: item?.recordId,
        name: item?.dependentName || '',
        email: item?.emailId === '0' ? '' : item?.emailId,
        address: item?.address === '0' ? '' : item?.address || '',
        mobileNo: item?.mobileNo === '0' ? '' : item?.mobileNo || '',
        passport: item?.passportNo === '0' ? '' : item?.passportNo || '',
        age: item?.age === 0 ? '' : item?.age || '',
        poBox: item?.poBoxNo === '0' ? '' : item?.poBoxNo || '',
        occupation: item?.occupation === '0' ? '' : item?.occupation || '',
        dateofBirth: item?.dateOfBirth === '1899-12-31T00:00:00' ? '' : item?.dateOfBirth || '',
        nationality: { label: item?.nationality === '0' ? '' : item?.nationality, value: item?.nationality } || null,
        country: { label: item?.country === '0' ? '' : item?.country, value: item?.country } || null,
        city: { label: item?.city === '0' ? '' : item?.city, value: item?.city } || null,
        gender: { label: item?.gender === '0' ? '' : item?.gender, value: item?.gender } || null,
      }));

      // Documents was never fetched here at all (only Contacts/Address/Dependents
      // were) - ported from the original customerMaster/editCustomer.js, which
      // does load this tab's data on edit.
      const documentParams = new URLSearchParams();
      documentParams.append('Action', 'GetDocumentsByCustomerNo');
      documentParams.append('TenantNo', userData?.customerNo);
      const documentRes = await apiService.getApiParamater('CUSTOMER_RA_COMMON', `?${documentParams.toString()}`);
      const rawDocumentData = normalizeArray(documentRes?.data?.result?.data);
      const docTypes = res2?.data?.dropdowns?.documentType || [];
      const parseDocDate = (val) => {
        if (!val || val === '0' || val === '1899-12-31T00:00:00') return null;
        const d = new Date(val);
        return Number.isNaN(d.getTime()) ? val : d;
      };
      const mappedDocuments = rawDocumentData.map((item) => {
        const typeVal = item?.document_Type ?? item?.Document_Type ?? '';
        const typeHit = docTypes.find((d) => String(d.text) === String(typeVal) || String(d.value) === String(typeVal));
        const docPathRaw = item?.document_Path ?? item?.Document_Path ?? '';
        const urlRaw = item?.url ?? item?.Url ?? '';
        const docPath = docPathRaw === '0' ? '' : String(docPathRaw || '').trim();
        const docUrl = urlRaw === '0' ? '' : String(urlRaw || '').trim();
        const documentNoRaw = item?.document_No ?? item?.Document_No ?? '';
        const remarksRaw = item?.document_Desc ?? item?.Document_Desc ?? '';
        return {
          type: typeHit ? { label: typeHit.text, value: typeHit.value } : typeVal ? { label: typeVal, value: typeVal } : null,
          documentNo: documentNoRaw === '0' ? '' : String(documentNoRaw || ''),
          IssueDate: parseDocDate(item?.doc_IssueDate ?? item?.Doc_IssueDate),
          expiryDate: parseDocDate(item?.doc_ExpiryDate ?? item?.Doc_ExpiryDate),
          Remarks: remarksRaw === '0' ? '' : String(remarksRaw || ''),
          name: docPath,
          documentPath: docPath,
          url: docUrl,
          Document_Path: docPath,
          verified: false,
          file: null,
        };
      });

      setAddressList(mappedAddresses);
      setDependentList(mappDependent);
      setDocumentsList(mappedDocuments);
      setTableLoading(false);
    } catch (error) {
      console.error('Error fetching Customer data:', error);
      setTableLoading(false);
    }
  };
  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
    const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
    setGridVisibility(newGridVisibility);
  };
  const handleBackClick = () => {
    if (onClose) onClose();
  };
  const handleSave = async () => {
    try {
      setloader(true);
      const currentDatetimeUTC = new Date().toISOString();
      for (const rule of validationRules) {
        if (!transectionData?.[rule.key]) {
          setloader(false);
          toast.warning(rule.message);
          return;
        }
      }
      if (!/^\S+@\S+\.\S+$/.test(transectionData.email)) {
        setloader(false);
        toast.warning(t('customerMaster.validationMessages.enterValidEmail'));
        return;
      }
      let fullName = transectionData?.firstName + ' ' + transectionData?.lastName;
      // const validParam = new URLSearchParams();
      // validParam.append('Action', 'CheckPrimaryContact');
      // validParam.append('TenantNo', '0');
      // validParam.append('TenantName', fullName);
      // validParam.append('CustomerType', transectionData?.countryCode?.dialCode);
      // validParam.append('UnitRefNo', transectionData?.mobileNo);
      // const validRes = await apiService.getApiParamater('CUSTOMER_RA_COMMON', `?${validParam.toString()}`);
      // const value = Object.values(validRes?.result?.data || {})[0];
      // if (value) {
      //     setloader(false);
      //     toast.warning("User with this name already exists");
      //     return;
      // }
      const countryCode = transectionData?.countryCode?.dialCode?.toString() || '';
      const phoneWithoutCode = transectionData?.mobileNo?.toString().startsWith(countryCode)
        ? transectionData.mobileNo.toString().slice(countryCode.length)
        : transectionData.mobileNo;
      let customerMaster = {
        record_id: userData?.recordId,
        customertype: transectionData.type?.label || '',
        customer_no: userData?.customerNo,
        title: transectionData.title?.label,
        customer_Name: transectionData?.fullName || '',
        poBox: transectionData.poBox || '',
        mainaddress1: transectionData.address,
        mainaddress2: '0',
        maincountry: selectedCountry?.label || '',
        maincity: selectedCity?.label || '',
        mainContactno: transectionData?.mobileNo || '0',
        nationality: transectionData.nationality?.label || '0',
        source: transectionData.source?.label || '0',
        salesPerson: transectionData.salesPerson?.label || '0',
        agent: transectionData.agent?.label || '0',
        remarks: gLAccounts.remarks || '0',
        tradeLicNo: gLAccounts.idNo || '0',
        tL_issue_date: gLAccounts.issueDate || '01-jan-1900',
        tL_Expiry_date: gLAccounts.expiryDate || '01-jan-1900',
        permitted_Use: '0',
        category_Mix: gLAccounts.categoryMix?.label || '',
        contactPerson: '0',
        contactPersonNo: '0',
        email_id: transectionData.email || '0',
        occupation: transectionData?.firstName || '0',
        contactaddress: transectionData?.designation || '0',
        designation: '0',
        department: transectionData?.lastName || '0',
        cpNationality: transectionData.nationality?.label || '',
        cdate: gLAccounts.dateofBirth || '01-jan-1900',
        status: 'Active',
        exp1: transectionData.firstNameAR || '',
        exp2: transectionData.lastNameAR || '',
        exp3: currentDatetimeUTC,
        modify_by: userName || '',
        modify_on: currentDatetimeUTC,
        createdBy: userName || '',
        createdOn: currentDatetimeUTC,
        accountCode: gLAccounts.accountcode || '0',
        accountName: gLAccounts.accountname || '0',
        sgCode: gLAccounts.sgAccount || '0',
        exp4: transectionData?.leadtype?.label || '0',
        exp5: transectionData?.subsource?.label || '0',
        exp6: transectionData?.Exp6 || countryCode,
        // exp6: "+966",
        exp7: '0',
        exp8: transectionData?.companyName || transectionData?.fullName || '0',
        exp9: transectionData?.addressAR || '0',
        exp10: '0',
        exp11: '0',
        exp12: '0',
        exp13: '0',
        exp14: transectionData?.gender?.label || '0',
        exp15: '0',
        exp16: transectionData?.productType?.label || '0',
        exp17: '0',
        vatRegNo: gLAccounts.vatNo || '0',
        taxCode: gLAccounts?.taxCode?.value || 0,
        leadtype: transectionData.leadtype?.label || '0',
      };
      
      const additionalContatList = contactList?.map((item, index) => {
        return {
          cd_id: parseInt(item?.id) || 0,
          customer_id: userData?.customerNo,
          contact_type: item?.type?.label || '0',
          country_code: '0',
          area_code: '0',
          contact_no: item?.phone || '0',
          contactPersonBI: item?.contactPerson || '0',
        };
      });
      const activityLists = activityList?.map((item, index) => {
        return {
          recordId: 0,
          activityId: 0,
          leadId: item?.name || '0',
          customerNo: item?.name || '0',
          customerName: item?.name || '0',
          activityType: item?.type?.label || '0',
          activityPurpose: item?.name || '0',
          activityFromDate: '2025-12-21T05:52:41.499Z',
          activityToDate: '2025-12-21T05:52:41.499Z',
          description: item?.name || '0',
          status: item?.name || '0',
          priority: item?.name || '0',
          assignedTo: item?.name || '0',
          remarks: item?.name || '0',
          exp1: item?.name || '0',
          exp2: item?.name || '0',
          exp3: item?.name || '0',
          exp4: item?.name || '0',
          exp5: item?.name || '0',
          createdBy: userName || '0',
          createdOn: currentDatetimeUTC,
          modifiedBy: userName || '0',
          modifiedOn: currentDatetimeUTC,
        };
      });
      const customerDocumetsList = documentsList?.map((item, index) => {
        return {
          customer_No: '0',
          document_Type: item?.type?.label || '0',
          document_No: item?.documentNo || '0',
          document_Desc: item?.Remarks || '0',
          doc_IssueDate: item?.IssueDate || '0',
          doc_ExpiryDate: item?.expiryDate || '0',
          document_Path: item?.name || '0',
        };
      });
      const preferencesList = preferenceList?.map((item, index) => {
        return {
          recordId: 0,
          leadId: '0',
          customerNo: '0',
          interest: item?.interest?.label || '0',
          community: item?.community || '0',
          location: item?.location?.label || '0',
          property: item?.project?.label || '0',
          unit: item?.unitNo?.label || '0',
          unitType: item?.unitType?.label || '0',
          unitView: item?.view?.label || '0',
          floor: '0',
          bedrooms: item?.bedroom?.label || '0',
          budgetFrom: item?.budgetfrom || '0',
          budgetTo: item?.budgetTo || '0',
          unitArea: item?.unitArea || '0',
          exp1: '0',
          exp2: '0',
          exp3: '0',
          exp4: '0',
          exp5: '0',
          createdBy: userName || '0',
          createdOn: currentDatetimeUTC,
          modifiedBy: userName || '0',
          modifiedOn: currentDatetimeUTC,
        };
      });
      const additionalAddressList = addressList?.map((item, index) => {
        return {
          cD_ID: item?.id || '0',
          customeR_ID: userData?.customerNo,
          addresS_TYPE_ID: item?.type?.label || '0',
          pobox: item?.poBox || '0',
          linE1: item?.address1 || '0',
          linE2: item?.address2 || '0',
          linE3: '0',
          countrY_CODE: item?.country?.label || '0',
          citY_CODE: item?.city?.label || '0',
        };
      });
      const getSearchCustomerList = [
        {
          recordId: 0,
          customerNo: '0',
          accountCode: '0',
          customerType: transectionData?.type?.label || '0',
          customerName: fullName || '0',
          contactNo: transectionData?.phoneNo || '0',
          emailId: transectionData?.email || '0',
          salesPerson: transectionData?.salesPerson?.label || '0',
          source: transectionData?.source?.label || '0',
          nationality: transectionData?.nationality?.label || '0',
          agent: transectionData?.agent?.label || '0',
          city: selectedCity?.label || '0',
          country: selectedCountry?.label || '0',
          createdBy: userName || '0',
          createdOn: currentDatetimeUTC,
          modifiedBy: userName || '0',
          modifiedOn: currentDatetimeUTC,
        },
      ];
      const tenantDependentList = dependentList?.map((item, index) => {
        return {
          recordId: 0,
          customer_No: '0',
          relationType: item?.type?.label || '0',
          dependentName: item?.name || '0',
          gender: item?.gender?.label || '0',
          age: parseInt(item?.age) || 0,
          dateOfBirth: moment(item?.dateofBirth || '1900-01-01').format() || '1900-01-01T07:16:06.672Z',
          occupation: item?.occupation || '0',
          emailId: item?.email || '0',
          mobileNo: item?.mobileNo || '0',
          passportNo: item?.passport || '0',
          issueDate: '1900-01-01T07:16:06.672Z',
          expiryDate: '1900-01-01T07:16:06.672Z',
          nationality: item?.nationality?.label || '0',
          country: item?.country?.label || '0',
          city: item?.city?.label || '0',
          address: item?.address || '0',
          poBoxNo: item?.poBox || '0',
          createdBy: userName,
        };
      });

      const body = {
        customerMain: {
          customerMaster: customerMaster,
          additionalContatList: additionalContatList,
          activityList: activityLists,
          customerDocumetsList: customerDocumetsList,
          preferencesList: preferencesList,
          additionalAddressList: additionalAddressList,
          getSearchCustomerList: getSearchCustomerList,
          tenantDependentList: tenantDependentList,
          createLedger: gLAccounts?.createledger || false,
          custNo: '0',
          rblExpiredDocs: '0',
        },
      };
      const postRes = await apiService.put('EDIT_CUSTOMER_RA', body);
      if (postRes?.data?.statusCode === 201) {
        toast.success(t('customerMaster.validationMessages.updateSuccess'));
        setloader(false);
        if (onClose) onClose();
      } else {
        toast.warning(`${postRes?.data?.message}`);
        setloader(false);
      }
    } catch (error) {
      console.error('Error Save Data', error);
      setloader(false);
    } finally {
      setloader(false);
    }
  };
  const handleCountryChange = async (selectedOption) => {
    const params = new URLSearchParams();
    params.append('DropdownFor', 'CustCityDescByCountry');
    params.append('CascadText', selectedOption?.label);
    const res = await apiService.getApiParamater('CUSTOMER_CASCAD', `?${params.toString()}`);
    setCityList(res?.data?.items);
    setSelectedCountry(selectedOption);
    setSelectedCity(null);
    // fetchCities(selectedOption)
  };
  return (
    <div className="d-flex flex-column customer-modal-form" style={{ height: '85vh' }}>
      <div className="p-3 border-bottom d-flex align-items-center justify-content-between flex-shrink-0">
        <h5 className="mb-0">{t('customerMaster.viewFormTitle')}</h5>
        <button type="button" className="btn-close" aria-label="Close" onClick={handleBackClick}></button>
      </div>
      <div className="p-3" style={{ flex: 1, overflowY: 'auto', minHeight: 0 }}>
      <div className="border-box2 my-3 p-3" style={{ borderRadius: '8px' }}>
        <div className="nav nav-pills overslid d-flex gap-4 customer-modal-tabs">
          <div className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`} onClick={() => handleTabClick(0)}>
            {t('customerMaster.tabs.personalDetails')}
          </div>
          <div className={`dashitems sidebar-text center  ${activeTab === 4 ? 'sideActive' : ''}`} onClick={() => handleTabClick(4)}>
            {t('customerMaster.tabs.otherDetails')}
          </div>
          <div className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`} onClick={() => handleTabClick(1)}>
            {t('customerMaster.tabs.additionalContact')}
          </div>
          <div className={`dashitems sidebar-text center  ${activeTab === 7 ? 'sideActive' : ''}`} onClick={() => handleTabClick(7)}>
            {t('customerMaster.tabs.additionalAddress')}
          </div>
          <div className={`dashitems sidebar-text center  ${activeTab === 8 ? 'sideActive' : ''}`} onClick={() => handleTabClick(8)}>
            {t('customerMaster.tabs.dependentDetails')}
          </div>
          <div className={`dashitems sidebar-text center  ${activeTab === 2 ? 'sideActive' : ''}`} onClick={() => handleTabClick(2)}>
            {t('customerMaster.tabs.documentsDetails')}
          </div>
          <div className={`dashitems sidebar-text center  ${activeTab === 5 ? 'sideActive' : ''}`} onClick={() => handleTabClick(5)}>
            {t('customerMaster.tabs.preference')}
          </div>
          <div className={`dashitems sidebar-text center  ${activeTab === 3 ? 'sideActive' : ''}`} onClick={() => handleTabClick(3)}>
            {t('customerMaster.tabs.activity')}
          </div>
          <div className={`dashitems sidebar-text center  ${activeTab === 6 ? 'sideActive' : ''}`} onClick={() => handleTabClick(6)}>
            {t('customerMaster.tabs.deal')}
          </div>
        </div>
      </div>
      {/* Lease Details */}
      {gridVisibility[0] && (
        <PersonalDetails
          tableLoading={tableLoading}
          nationalityList={nationalityList}
          countriesList={countriesList}
          cityList={cityList}
          handleCountryChange={handleCountryChange}
          sourceList={sourceList}
          customerTypeList={customerTypeList}
          salesPersonList={salesPersonList}
          selectedCity={selectedCity}
          setTransectionData={setTransectionData}
          leadStatus={leadStatus}
          selectedCountry={selectedCountry}
          setSelectedCountry={setSelectedCountry}
          setSelectedCity={setSelectedCity}
          transectionData={transectionData}
          agentList={agentList}
          titleList={titleList}
          leadType={personalTabLeadType}
          categoryMix={categoryMix}
          defaultCountry={defaultCountry}
          packageName={packageName}
        />
      )}
      {gridVisibility[1] && (
        <ContactDetails
          setContactList={setContactList}
          addContactType={addContactType}
          contactList={contactList}
          currencyPrecision={currencyPrecision}
          defaultCountry={defaultCountry}
        />
      )}
      {gridVisibility[7] && (
        <AddressDetails
          setAddressList={setAddressList}
          addAddressType={addAddressType}
          addressList={addressList}
          countriesList={countriesList}
          cityList={cityList}
          currencyPrecision={currencyPrecision}
          defaultCountry={defaultCountry}
        />
      )}
      {gridVisibility[2] && <DocumentDetails documentType={documentType} setDocumentsList={setDocumentsList} documentsList={documentsList} />}
      {gridVisibility[3] && (
        <Activity
          activityRating={activityRating}
          language={language}
          woContact={woContact}
          activityStatus={activityStatus}
          setActivityList={setActivityList}
          activityList={activityList}
          ativityLeadType={ativityLeadType}
        />
      )}

      {gridVisibility[4] && (
        <GLAccount
          gLAccounts={gLAccounts}
          categoryMix={categoryMix}
          transectionData={transectionData}
          countriesList={countriesList}
          setGLAccounts={setGLAccounts}
          taxList={taxList}
          acountCodes={acountCodes}
        />
      )}
      {gridVisibility[5] && (
        <PreferenceDetails
          setPreferenceList={setPreferenceList}
          prefIntrest={prefIntrest}
          prefBuying={prefBuying}
          Properties={Properties}
          UnitTypeDesc={UnitTypeDesc}
          preferenceList={preferenceList}
          locationMaster={locationMaster}
          UnitClass={UnitClass}
          UnitView={UnitView}
          UnitModel={UnitModel}
          packageName={propertylist}
          bedRooms={bedRooms}
        />
      )}
      {gridVisibility[8] && (
        <DependentDetails
          setDependentList={setDependentList}
          addAddressType={addAddressType}
          dependentList={dependentList}
          countriesList={countriesList}
          cityList={cityList}
          currencyPrecision={currencyPrecision}
          defaultCountry={defaultCountry}
        />
      )}
      </div>
      <div className="p-3 border-top d-flex justify-content-start gap-3 flex-shrink-0">
        {loading === true ? (
          <div className="mainbtn flex-end gap-2">
            <ClipLoader color="#ffffff" className="mt-1" size={20} />
          </div>
        ) : (
          <div className="mainbtn flex-end gap-2" onClick={handleSave}>
            <FaSave color="#fff" className="center mt-1 mx-2" />
            <div className="center">{t('common.save')}</div>
          </div>
        )}
        <div className="mainbtnRed flex-end gap-2" onClick={handleBackClick}>
          <FaChevronLeft color="#fff" className="center mt-1 mx-2" />
          <div className="center">{t('common.cancel')}</div>
        </div>
      </div>
    </div>
  );
};
export default ViewCustomerMaster;
